"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCustomerContactUpdate = exports.BaseCustomerContactCreate = exports.BaseCustomerContact = exports.ContactAccess = exports.UpdateNotificationPreferences = exports.NotificationPreferences = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const nullable_1 = require("../common/nullable");
const communication_1 = require("../notification/communication");
exports.NotificationPreferences = typebox_1.Type.Unsafe(typebox_1.Type.Record(communication_1.CommunicationType, typebox_1.Type.Array(common_1.NotificationDeliveryMethod)));
exports.UpdateNotificationPreferences = typebox_1.Type.Unsafe(typebox_1.Type.Partial(typebox_1.Type.Record(typebox_1.Type.Partial(communication_1.CommunicationType), typebox_1.Type.Array(common_1.NotificationDeliveryMethod))));
exports.ContactAccess = typebox_1.Type.Object({
    // note: not sure why it fails on enum, using literal instead
    type: typebox_1.Type.Literal('SERVICE_LOCATION'),
    referenceID: typebox_1.Type.String(),
});
exports.BaseCustomerContact = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    notificationPreferences: exports.NotificationPreferences,
    primaryContact: typebox_1.Type.Boolean(),
    locationPreferences: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
    email: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'email' })),
    firstName: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastName: typebox_1.Type.Optional(typebox_1.Type.String()),
    phoneNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    department: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: common_1.MetaData,
    access: typebox_1.Type.Array(exports.ContactAccess),
    // TODO: Remove these once we cut Sourgum to notification preferences
    sendBillingEmails: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    sendDispatchEmails: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
exports.BaseCustomerContactCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.BaseCustomerContact, ['id', 'metadata', 'notificationPreferences', 'access']),
    typebox_1.Type.Object({
        notificationPreferences: typebox_1.Type.Optional(exports.UpdateNotificationPreferences),
        access: typebox_1.Type.Optional(typebox_1.Type.Array(exports.ContactAccess)),
    }),
]);
exports.BaseCustomerContactUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.BaseCustomerContact, [
        'id',
        'metadata',
        'notificationPreferences',
        'email',
        'lastName',
        'phoneNumber',
        'notes',
        'department',
    ]),
    typebox_1.Type.Object({
        notificationPreferences: exports.UpdateNotificationPreferences,
        email: (0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'email' })),
        lastName: (0, nullable_1.Nullable)(typebox_1.Type.String()),
        phoneNumber: (0, nullable_1.Nullable)(typebox_1.Type.String()),
        notes: (0, nullable_1.Nullable)(typebox_1.Type.String()),
        department: (0, nullable_1.Nullable)(typebox_1.Type.String()),
        access: (0, nullable_1.Nullable)(typebox_1.Type.Array(exports.ContactAccess)),
    }),
]));
//# sourceMappingURL=base-customer-contact.js.map